// extracted by mini-css-extract-plugin
export default {"pageLoader":"PageLoader_pageLoader__areWG","show":"PageLoader_show__NuJ1L"};